import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=e72caf64"
import script from "./CustomDashboard.vue?vue&type=script&lang=js"
export * from "./CustomDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomDashboard.vue?vue&type=style&index=0&id=e72caf64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports